import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router'
import List from './../common/List'
import { Button, ButtonToolbar } from 'react-bootstrap'
import style from './styles.less'

class Users extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataColumnsNames: [
                'Usuario', 'Email', 'Acciones'
            ],
            showModal: false
        }

        this.props.actions.userGet = this.props.actions.userGet.bind(this, this.props.params.appCodename)
        this.props.actions.userClean = this.props.actions.userClean.bind(this)
        this.confirmDeleteData = this.confirmDeleteData.bind(this)
    }

    deleteData(dataId) {
        let self = this
        var list = self.list.getWrappedInstance()
        return list.openModal({
            title: 'Eliminar usuario',
            description: '¿Está seguro que desea eliminar este usuario?',
            button: {
                cancel: {
                    title: 'Cancelar',
                    className: 'btn-default'
                },
                success: {
                    title: 'Eliminar',
                    className: 'btn-danger',
                    onClick: self.confirmDeleteData,
                    onClickBind: self
                }
            }
        }, {
            dataId: dataId
        })
    }

    confirmDeleteData(metadata) {
        var self = this
        var list = self.list.getWrappedInstance()
        var promise = Promise.resolve()

        self.setState({ loading: true })
        promise = promise.then(() => {
            return self.props.actions.userDelete(self.props.params.appCodename, metadata.dataId)
        }).then(() => {
            return list.refreshData(true)
        }).then(() => {
            return list.closeModal()
        }).then(() => {
            self.setState({ loading: false })
        })

        return promise
    }

    dataObjectProcess(user) {
        let self = this
        let row = []
        row.push(
            <Link to={`/manager/${self.props.params.appCodename}/user/${user._id}`}>{user.displayName}</Link>
        )
        row.push(user.emails[0].value)
        if (user._id !== self.props.profile._id) {
            row.push(
                <ButtonToolbar>
                    <Button onClick={self.deleteData.bind(self, user._id)} type="button" className="btn btn-danger" disabled={ self.state.loading }>
                        <span className="fa fa-trash fa-fw"></span>
                    </Button>
                    <Link to={`/manager/${self.props.params.appCodename}/user/edit/${user._id}`} type="button" className="btn btn-primary" disabled={ self.state.loading }>
                        <span className="fa fa-pencil fa-fw"></span>
                    </Link>
                </ButtonToolbar>
            )
        } else {
            row.push(
                <div></div>
            )
        }
        return row
    }

    render() {
        let self = this
        let content
        let itemsProcessed = []

        if (self.props.users && self.props.profile && self.props.profile.profile === 2000) {
            self.props.users.forEach(function(user) {
                itemsProcessed.push(self.dataObjectProcess(user))
            })
        }

        let description =
        <div className="row">
            <div className="col-xs-10">
                <span className={style.description}>Datos de los usuarios del manager</span>
            </div>
            <div className="col-xs-2">
                <Link to={`/manager/${self.props.params.appCodename}/user/add`} type="button" className="btn btn-primary pull-right" disabled={ self.state.loading }>
                    <span className="fa fa-plus fa-fw"></span>
                </Link>
            </div>
        </div>

        content = <List ref={(list) => { self.list = list }}
                    items={itemsProcessed}
                    name="Usuarios"
                    dataColumnsNames={self.state.dataColumnsNames}
                    description={description}
                    getObjects={self.props.actions.userGet}
                    clearObjects={self.props.actions.userClean}
                    routing={self.props.routing}/>

        return (
            <div>
                {content}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        users: state.users,
        profile: state.profile,
        routing: state.routing
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Users)



// WEBPACK FOOTER //
// ./components/Users/index.js